export function getdata() {
	var obj = {
		searchlist: [{
				prop: "companyCode",
				label: '公司代码',
				type: "input"
			},
			{
				prop: "companyName",
				label: '公司名称',
				type: "input"
			},
			{
				prop: "startBalanceDebit",
				label: '期初余额（借方）',
				type: "inputplus"
			},
			{
				prop: "startBalanceCredit",
				label: '期初余额（贷方）',
				type: "inputplus"
			},
			{
				prop: "currentBalanceDebig",
				label: '本期发生额（借方）',
				type: "inputplus"
			},
			{
				prop: "endBalanceDebig",
				label: '期末发生额（借方）',
				type: "inputplus"
			},
			{
				prop: "period",
				label: '税款所属期间',
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
		],
		searchdata: {
			suosq: "",
		},
		headData: [{
				title: "公司名称",
				prop: "goufmc",
				width: "250",
				custom:true

			},
			{
				title: "票据张数",
				prop: "piaojzs",
				width: "250",
				custom:true
			},
			{
				title: "金额",
				prop: "jinge",
				width: "250",
				custom:true

			},
			{
				title: "税额",
				prop: "shuie",
				width: "250",
				custom:true

			},
		],
		outputData: {
			exportType: "",
			suosq: "",
		},
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		}
	}
	return obj
}
